import loadable from '@loadable/component'

export default [
  {
    path: '/redEnvelope/record',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-RedEnvelope-record" */ '~/pages/RedEnvelope/pages/record'
        )
    ),
  },
  {
    path: '/redEnvelope/detail',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-RedEnvelope-detail" */ '~/pages/RedEnvelope/pages/detail'
        )
    ),
  },
  {
    path: '/redEnvelope/rule',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-RedEnvelope-rule" */ '~/pages/RedEnvelope/pages/rule'
        )
    ),
  },
]
